import { motion } from "framer-motion";
import { Search } from "lucide-react";

const TipsHero = () => {
  return (
    <section
      className="
relative
bg-gray-50
py-20
overflow-hidden
"
    >
      {/* Background decoration */}

      <div
        className="
absolute
right-0
top-0
w-72
h-72
bg-green-100
rounded-full
blur-3xl
opacity-70
"
      ></div>

      <div
        className="
relative
z-10
max-w-7xl
mx-auto
px-6
text-center
"
      >
        <motion.div
          initial={{
            opacity: 0,
            y: 30,
          }}
          animate={{
            opacity: 1,
            y: 0,
          }}
          transition={{
            duration: 0.7,
          }}
        >
          <h1
            className="
text-4xl
md:text-5xl
font-bold
text-gray-900
"
          >
            Healthcare Tips &
            <span
              className="
text-green-600
"
            >
              Advice
            </span>
          </h1>

          <p
            className="
mt-6
max-w-2xl
mx-auto
text-lg
text-gray-600
"
          >
            Learn how to choose, use, and care for healthcare equipment for
            better comfort, safety, and quality of life.
          </p>

          {/* Search */}

          <div
            className="
mt-8
max-w-xl
mx-auto
relative
"
          >
            <Search
              className="
absolute
left-4
top-1/2
-translate-y-1/2
text-gray-400
"
            />

            <input
              type="text"
              placeholder="Search health tips..."
              className="
w-full
pl-12
pr-5
py-4
rounded-full
border
border-gray-200
bg-white
focus:outline-none
focus:ring-2
focus:ring-green-500
"
            />
          </div>
        </motion.div>
      </div>
    </section>
  );
};

export default TipsHero;
